import { hooks } from 'botframework-webchat';
import React, { useCallback } from 'react';
const { usePostActivity } = hooks;
export const BFFWebSearchButton = (props) => {
    const postActivity = usePostActivity();
    const handleWebSearch = useCallback(() => {
        const webSearch = props === null || props === void 0 ? void 0 : props.webSearch;
        const activityId = props === null || props === void 0 ? void 0 : props.activityId;
        if (webSearch && activityId) {
            postActivity(buildWebSearchActivity(webSearch.query, webSearch.intentId, activityId));
        }
    }, [props === null || props === void 0 ? void 0 : props.webSearch, postActivity, props === null || props === void 0 ? void 0 : props.activityId]);
    return (props === null || props === void 0 ? void 0 : props.webSearch) ? (React.createElement("button", { onClick: handleWebSearch, "aria-label": props.webSearch.spokenLabel || props.webSearch.label }, props.webSearch.label)) : (React.createElement(React.Fragment, null));
};
const buildWebSearchActivity = (searchTerm, intentId, replyToId) => ({
    type: 'message',
    value: {
        type: 'searchRelatedToAnswer',
        searchTerm,
        intentId
    },
    replyToId
});
//# sourceMappingURL=bffWebSearchButton.js.map